import { render, staticRenderFns } from "./ComplementaryExam.vue?vue&type=template&id=1132cad5&scoped=true"
import script from "./ComplementaryExam.vue?vue&type=script&lang=js"
export * from "./ComplementaryExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132cad5",
  null
  
)

export default component.exports